import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'error-page',
  templateUrl: './errorpage.component.html',
  styleUrls: ['./errorpage.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
